import { FormError } from "app/containers/types";
import { StationForm, StationTypes } from "../../types";
import toastService from "utils/toast";
export const validateStation = (form: StationForm,t:any): FormError[] => {
  let errors: FormError[] = [];

  if (!form.name.value) {
    errors.push({
      name: "name",
      error: "STATIONS.ERRORS.NAME_IS_REQUIRED",
    });
    toastService.error(
      t("STATIONS.ERRORS.NAME_IS_REQUIRED")
    );
  }

 

  if (form.type.value === StationTypes.POINT) {
    if (!form.address.value) {
      errors.push({
        name: "address",
        error: "STATIONS.ERRORS.ADDRESS_IS_REQUIRED",
      });
      toastService.error(
        t("STATIONS.ERRORS.ADDRESS_IS_REQUIRED")
      );
    }
    if (!form.coordinates?.value?.length) {
      errors.push({
        name: "coordinates",
        error: "STATIONS.ERRORS.COORDINATES_IS_REQUIRED",
      });
      toastService.error(
        t("STATIONS.ERRORS.COORDINATES_IS_REQUIRED")
      );
    }
    if (!form.radius.value) {
      errors.push({
        name: "radius",
        error: "STATIONS.ERRORS.RADIUS_IS_REQUIRED",
      });
      toastService.error(
        t("STATIONS.ERRORS.RADIUS_IS_REQUIRED")
      );
    }
    if (form.radius.value && Number(form.radius.value) > 10000) {
      errors.push({
        name: "radius",
        error: "STATIONS.ERRORS.RADIUS_MAX_NOT_SUPPORTED",
      });
      toastService.error(
        t("STATIONS.ERRORS.RADIUS_MAX_NOT_SUPPORTED")
      );
    }
  }

  if (form.type.value === StationTypes.QR) {
    if (!form.qrText.value) {
      errors.push({
        name: "qrText",
        error: "STATIONS.ERRORS.QR_TEXT_IS_REQUIRED",
      });
    }
  }

  if (form.type.value === StationTypes.CODE) {
    if (!form.code.value) {
      errors.push({
        name: "code",
        error: "STATIONS.ERRORS.CODE_IS_REQUIRED",
      });
    }
  }

  // if(!form.stationImageId.value) {
  //   errors.push({
  //     name: "stationImageUrl",
  //     error: "STATIONS.ERRORS.STATION_IMAGE_IS_REQUIRED",
  //   });
  // }

  // if(!form.stationImageUrl.value) {
  //   errors.push({
  //     name: "stationImageUrl",
  //     error: "STATIONS.ERRORS.STATION_IMAGE_IS_REQUIRED",
  //   });
  // }

  return errors;
};
